import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-bg" }, null, -1)
const _hoisted_3 = { class: "header-container" }
const _hoisted_4 = { class: "header-breadcrumb" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Menu", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "dots" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "dots" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "dots" }, null, -1)
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "header-nav" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "✕", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["href", "title"]

import { useLinks } from "@/hooks/useLinks";


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const links = useLinks();

function openMenu(): void {
  document.body.classList.add("is-nav-open");
}
function closeMenu(): void {
  document.body.classList.remove("is-nav-open");
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$route.name), 1),
      _createElementVNode("button", {
        title: "Open menu",
        type: "button",
        class: "header-nav-button",
        onClick: openMenu
      }, _hoisted_9),
      _createElementVNode("nav", _hoisted_10, [
        _createElementVNode("button", {
          title: "Close menu",
          type: "button",
          class: "header-nav-close-button",
          onClick: closeMenu
        }, _hoisted_12),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { name: '.is()' },
              title: "Home"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" .is() ")
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { name: '.about()' },
              title: "About me"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" .about() ")
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (link) => {
            return (_openBlock(), _createElementBlock("li", {
              key: link.url,
              class: "social-link"
            }, [
              _createElementVNode("a", {
                href: link.url,
                title: link.title,
                target: "_blank"
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(link.icon)))
              ], 8, _hoisted_13)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})